import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useT } from '../i18n/i18n';
import { useMediaVersion } from './media';
import { usageLine, type MediaUsage } from './usage';

export default function UsageLine() {
  const t = useT();
  const version = useMediaVersion();
  const [usage, setUsage] = useState<MediaUsage | null>(null);

  useEffect(() => {
    let live = true;
    api<MediaUsage>('/media/usage', { token: true }).then((u) => { if (live) setUsage(u); }).catch(() => { if (live) setUsage(null); });
    return () => { live = false; };
  }, [version]);

  if (!usage) return null;
  return <p className="field-hint tb-usage">{usageLine(usage, t)}</p>;
}
